<template>
<div class="wordhomw-wrap">
  <div data-v-7a63e4b3="" class="v-note-wrapper markdown-body shadow"><h1><a></a>快速入门</h1>
    <ul>
      <li><a href="#">代码结构图</a></li>
    </ul>
  </div>

</div>
</template>

<script>
export default {
  name: "wordCom2"
}
</script>

<style scoped>

</style>
